import {useEffect, useState} from "react";
import {Link, Navigate, useNavigate, useParams} from "react-router-dom";
import {getAccountOrder, getAccountProfile, type AccountOrder, type AccountProfile} from "@corporatesclub/shared";
import {AccountChrome, accountLogout} from "@/components/shop/AccountChrome";
import {OrderDetailView} from "@/components/shop/OrderDetailView";
import {ShopSkeleton} from "@/components/shop/ShopSkeleton";
import {useI18n} from "@/components/shop/I18nProvider";
import {paths} from "@/lib/paths";

export function AccountOrderDetailPage() {
  const {t} = useI18n();
  const navigate = useNavigate();
  const {orderId} = useParams<{orderId: string}>();
  const id = orderId ? parseInt(orderId, 10) : 0;
  const [profile, setProfile] = useState<AccountProfile | null>(null);
  const [order, setOrder] = useState<AccountOrder | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if(!id) return;
    setLoading(true);
    setError("");
    Promise.all([
      getAccountProfile(),
      getAccountOrder(id)
    ]).then(([p, o]) => {
      setProfile(p);
      setOrder(o);
    }).catch((e: Error) => {
      setError(e.message || t("Product not found"));
      setOrder(null);
    }).finally(() => setLoading(false));
  }, [id, t]);
  if(!id) return <Navigate to={paths.account} replace />;
  if(error && !loading) return (
    <div className="cc-account">
      <p className="cc-account__alert">{error}</p>
      <p><Link to={paths.account} className="cc-account__back anim"><i className="fa fa-angle-left" /> {t("Back to orders")}</Link></p>
    </div>
  );
  if(!profile || loading) return <div className="cc-account cc-account--loading"><ShopSkeleton lines={8} /></div>;
  if(!order) return <Navigate to={paths.account} replace />;
  return (
    <AccountChrome
      profile={profile}
      activeTab=""
      title={`${t("Order")} #${order.displayNumber}`}
      subtitle={order.statusLabel}
      backTo={{label: t("Back to orders"), href: paths.account}}
      onLogout={(e) => { e.preventDefault(); accountLogout(navigate); }}
    >
      <div className="cc-account__panel cc-account__panel--enter">
        <OrderDetailView order={order} />
      </div>
    </AccountChrome>
  );
}
